import { OrganizationDto } from "../../common/service/server/dto/OrganizationDto";

/**
 * Organization feature flags that unlock the "Ramsay" section of the app. The section shows when any of
 * them is on; add to this list as more Ramsay features grow their own flags.
 *
 * Mirrors `Features.RAMSAY_SECTION_FEATURES` on the backend.
 */
export const RAMSAY_SECTION_FEATURES: (keyof OrganizationDto)[] = ["featureServiceAccounts"];

export const isRamsaySectionEnabled = (organization: OrganizationDto | null | undefined): boolean =>
  !!organization && RAMSAY_SECTION_FEATURES.some((feature) => organization[feature] === true);

export const isServiceAccountsEnabled = (
  organization: OrganizationDto | null | undefined,
): boolean => organization?.featureServiceAccounts === true;
